import React from "react";

export const CROSSWALK_REFERENCE_SOURCE_COLUMNS = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: "50%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    width: "50%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
];
